import BaseComponent from "../../../../base/base_component";
import { USER_EVENTS} from "../../../../events/events";
const view = require('./view/michigan_responsible_gaming_icons.html');

export default class MichiganResponsibleGamingIconsController extends BaseComponent {
    static CLASS = 'MichiganResponsibleGamingIconsController';

    start() {
        let bakedHTML = this.bake(view);
        this.setHTML(bakedHTML);
        this._subscribe();
    }

    _subscribe() {
        this.onDOMEvent(this.querySelector('.cgp-regulatory-button.cgp-michigan-responsible-gaming-icon'), USER_EVENTS.ON_CLICK, () => {
            this._sendAnalytics('michigan_responsible_gaming_click');
            this.serviceFactory.openLinkService().openResponsibleGamblingLink();
        });
    }

    _sendAnalytics(label) {
        this.serviceFactory.analyticsService().sendClickstreamEvent(
            {
                eventName:'Orbit_User_Flow',
                category:'Navigation',
                action: 'Header',
                label:'Icon_' + label
            });
    }
}
